<template>
  <div class="VueModal" :class="{ 'Show': isShow, 'VueModal-Fade': isFade }">
    <div ref="backdrop" class="VueModal-Backdrop" :class="{ 'Animated': isFade && showingAnimation }" @click="close()">
    </div>

    <div ref="content" class="VueModal-Content" :class="{ 'Animated': isFade && showingAnimation }">
      <div class="VueModal-Header" v-if="showHeader">
        <div class="VueModal-Title">{{ resolvedTitle }}</div>
        <div class="VueModal-HeaderActions">
          <button type="button" class="VueModal-Close" aria-label="Close" @click="close()">×</button>
          <!-- 可选：关闭按钮下方额外操作（如 BR 预览「重新上传」） -->
          <slot name="header-extra"></slot>
        </div>
      </div>
      <div class="VueModal-Body">
        <div class="VueModal-Frame">
          <div class="VueModal-Square">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  model: {
    event: 'change'
 },
  props: {
    value:
    {
      type:Boolean,
      default:false
    },
    onBeforeShow: {
      type: Function,
      default: () => (() => { }),
    },
    onAfterShow: {
      type: Function,
      default: () => (() => { }),
    },
    onBeforeClose: {
      type: Function,
      default: () => (() => { }),
    },
    onAfterClose: {
      type: Function,
      default: () => (() => { }),
    },
    isWindowNoScroll: {
      type: Boolean,
      default: true,
    },
    isFade: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isShow: true,
      bodyOverflow: "",
      showingAnimation: false,
    }
  },
  created() {
    this.isShow = this.value;
  },
  computed: {
    resolvedTitle() {
      if (this.title) return this.title;
      return this.$t('lbl_EMPBE_PreviewImage');
    },
  },
  watch: {
    value()
    {
      this.isShow = this.value;
    },
    isShow(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (newVal === true) {
        this.showingAnimation = false;
        this.show();

        this.$nextTick(function () {
          this.showingAnimation = true;
        });
      }

      if (newVal === false) {
        this.close();
      }
    }
  },
  mounted() {

  },
  methods: {
    close() {
      if (this.onBeforeClose) {
        this.onBeforeClose();
      }

      this.toggleShow(false);

      if (this.onAfterClose) {
        this.onAfterClose();
      }
    },

    show() {
      if (this.onBeforeShow) {
        this.onBeforeShow();
      }

      this.toggleShow(true);

      if (this.onAfterShow) {
        this.onAfterShow();
      }
    },

    toggleShow(isShow) {
      this.isShow = isShow;
      this.toggleWindowNoScroll(isShow);
      this.$emit('change', isShow);
    },

    toggleWindowNoScroll(isNoScroll) {
      if (isNoScroll) {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return;
      }

      document.body.style.overflow = this.bodyOverflow;
    },
  }
}
</script>
<style scoped lang="css">
    .VueModal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1040;
        justify-content: center;
        align-items: center;
        display: none;
    }

        .VueModal.Show {
            display: flex;
        }

        .VueModal > .VueModal-Backdrop {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #000;
            z-index: 1041;
        }

        .VueModal > .VueModal-Content {
            width: fit-content;
            max-width: calc(100% - 3rem);
            max-height: calc(100% - 3rem);
            background-color: #fff;
            z-index: 1042;
            margin: auto;
            border: 1px solid rgba(0, 0, 0, 0.10);
            border-radius: 12px;
            overflow: hidden;
        }

        .VueModal-Header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 16px 20px;
            gap: 12px;
        }

        .VueModal-Title {
            color: rgba(0, 0, 0, 0.8);
            font-size: 18px;
            font-weight: 700;
            line-height: 1.3;
            flex: 1;
            min-width: 0;
            padding-top: 4px;
        }

        .VueModal-HeaderActions {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            gap: 8px;
        }

        .VueModal-Close {
            border: none;
            background: transparent;
            color: rgba(0, 0, 0, 0.45);
            font-size: 32px;
            line-height: 1;
            cursor: pointer;
            padding: 0;
            margin: 0;
        }

        .VueModal-Body {
            padding: 24px 20px;
            max-height: calc(100vh - 3rem - 72px);
            overflow: auto;
        }

        .VueModal-Frame {
            background: #fff;
            border-radius: 8px;
            width: fit-content;
            max-width: min(100%, 90vw);
            margin: 0 auto;
            overflow: hidden;
        }

        .VueModal-Square {
            width: min(72vh, 84vw);
            aspect-ratio: 1 / 1;
            background: #F9F9F9;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        }

        .VueModal-Frame ::v-deep img:not(.br-status-badge__icon) {
            display: block;
            margin: 0 auto;
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            object-position: center;
        }

        .VueModal.VueModal-Fade > .VueModal-Backdrop {
            opacity: 0;
        }

            .VueModal.VueModal-Fade > .VueModal-Backdrop.Animated {
                transition: opacity 0.15s linear;
                opacity: 0.5;
            }

        .VueModal.VueModal-Fade > .VueModal-Content {
            transform: scale(0.85);
        }

            .VueModal.VueModal-Fade > .VueModal-Content.Animated {
                transition: transform 0.15s linear;
                transform: scale(1);
            }
</style>
